<template>
  <div class="EditContainer mb20">
    <div class="w200 mb20">
      <div class="mb4"><span class="red">*</span>状态：</div>
      <a-radio-group
        :disabled="notDefaultLang"
        :options="statusOptions"
        v-model:value="popupParams.status"
      />
    </div>
    <div class="w700 mb20">
      <div class="mb4"><span class="red">*</span>展示弹窗：</div>
      <a-radio-group
        :disabled="notDefaultLang"
        :options="alertFormOptions"
        v-model:value="popupParams.popType"
      />
    </div>
    <div class="w500 mb20">
      <div class="mb4 label-df">
        弹框背景色(仅订阅生效)：
        <colorPicker
          v-if="!notDefaultLang"
          format="rgb"
          placement="bottom-start"
          v-model:pureColor="popupParams.backColor"
        ></colorPicker>

        <div
          class="colorBlock"
          :style="
            `background: ${popupParams.backColor || 'rgba(255,255,255,1)'};`
          "
          v-else
        ></div>
      </div>
    </div>
    <div class="w400 mb20">
      <div class="mb4"><span class="red">*</span>每个用户仅弹出一次：</div>
      <div class="radio-wrapper">
        <a-radio-group
          :disabled="notDefaultLang"
          :options="alertTimesOptions"
          v-model:value="popupParams.oncePopPerUser"
        />
        <div class="radio-tips" v-if="!popupParams.oncePopPerUser">
          弹出频次：每隔
          <a-input
            :disabled="notDefaultLang"
            class="input-style"
            v-model:value="popupParams.popFrequency"
          ></a-input>
          天，弹出一次
        </div>
      </div>
    </div>
    <div class="w800 mb20">
      <div class="mb4"><span class="red">*</span>请选择触发用户类型：</div>
      <a-radio-group
        :disabled="notDefaultLang"
        :options="triggerOptions"
        v-model:value="popupParams.userType"
      />
    </div>
    <div class="w800 mb20">
      <div class="mb10"><span class="red">*</span>弹窗延迟出现设置：</div>
      <div class="df">
        <div class="lh30">0s</div>
        <div class="w300">
          <a-slider
            :disabled="notDefaultLang"
            v-model:value="popupParams.delayTime"
            :min="1"
            :max="20"
          />
        </div>
        <div class="lh30">20s</div>
      </div>
    </div>
    <div class="w400 mb10" v-if="queryParams?.terminalId === '1'">
      <div class="mb4 label-df">
        <span class="red">*</span>请选择侧边栏类型：
        <div class="label-checked">
          <a-checkbox
            :disabled="notDefaultLang"
            v-model:checked="popupParams.sidebarShowCloseButton"
            >展示关闭按钮</a-checkbox
          >
        </div>
      </div>
      <a-radio-group
        class="mb20"
        :options="sideTypeOptions"
        v-model:value="popupParams.sidebarType"
        @change="
          () => {
            popupParams.sidebarContent = null
            popupParams.sidebarIndividuationImage = null
          }
        "
      />
      <div>
        <a-input
          v-if="popupParams.sidebarType - 0 === 1"
          class="w300 mb10"
          v-model:value="popupParams.sidebarContent"
          placeholder="请输入（建议20个字符以内）"
        />
        <div v-if="popupParams.sidebarType - 0 === 3">
          <div><span class="red">*</span>文案：</div>
          <a-input
            class="w300 mb10"
            v-model:value="popupParams.sidebarContent"
            placeholder="请输入"
            @change="
              lengthCut(
                popupParams.sidebarContent,
                'sidebarContent',
                'popupParams',
                50
              )
            "
          />
          <div class="w120 h120 sidebarTypeImg pr">
            <a-upload-dragger
              :fileList="[]"
              :show-upload-list="false"
              name="file"
              :multiple="true"
              :customRequest="e => upload(e, null, 'sidebarIndividuationImage')"
              :accept="'.png,.jpg,.jpeg,.gif'"
              :headers="uploadHeaders"
            >
              <div
                v-if="
                  ['', null].includes(popupParams.sidebarIndividuationImage)
                "
              >
                <div
                  class="w120 h120 tac"
                  style="color: #666666; font-size: 40px; line-height: 120px;"
                >
                  <PictureOutlined />
                </div>
              </div>
            </a-upload-dragger>
            <div
              v-if="!['', null].includes(popupParams.sidebarIndividuationImage)"
              class="h100 pa l0 t0 sidebarContentBg"
              :style="
                `width: 120px; background: url('${popupParams.sidebarIndividuationImage}') center center/ cover no-repeat;`
              "
            >
              <div class="hover">
                <EyeOutlined
                  @click="
                    () =>
                      changeVisiblePic(
                        true,
                        popupParams.sidebarIndividuationImage
                      )
                  "
                />
                &nbsp;&nbsp;
                <DeleteOutlined
                  @click="popupParams.sidebarIndividuationImage = null"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w120 h120 sidebarTypeImg pr"
        v-if="popupParams.sidebarType - 0 === 2"
      >
        <a-upload-dragger
          :fileList="[]"
          :show-upload-list="false"
          name="file"
          :multiple="true"
          :customRequest="e => upload(e, null, 'sidebarContent')"
          :accept="'.png,.jpg,.jpeg,.gif'"
          :headers="uploadHeaders"
        >
          <div v-if="['', null].includes(popupParams.sidebarContent)">
            <div
              class="w120 h120 tac"
              style="color: #666666; font-size: 40px; line-height: 120px;"
            >
              <PictureOutlined />
            </div>
          </div>
        </a-upload-dragger>
        <div
          v-if="!['', null].includes(popupParams.sidebarContent)"
          class="h100 pa l0 t0 sidebarContentBg"
          :style="
            `width: 120px; background: url('${popupParams.sidebarContent}') center center/ cover no-repeat;`
          "
        >
          <div class="hover">
            <EyeOutlined
              @click="() => changeVisiblePic(true, popupParams.sidebarContent)"
            />
            &nbsp;&nbsp;
            <DeleteOutlined @click="popupParams.sidebarContent = null" />
          </div>
        </div>
      </div>
    </div>
    <div class="w400 mb10" v-if="queryParams?.terminalId === '1'">
      <div class="mb4"><span class="red">*</span>不展示的路由：</div>
      <a-input
        :disabled="notDefaultLang"
        class="w300"
        v-model:value="popupParams.filterUrl"
        placeholder="多个路由以；分割"
      />
    </div>
    <div class="w400 mb10" v-if="queryParams?.terminalId === '2'" :key="1">
      <div class="mb4">生效页面：</div>
      <a-select
        :disabled="notDefaultLang"
        class="w300"
        mode="multiple"
        allowClear
        v-model:value="popupParams.filterUrl"
        :options="effectivePageList"
      />
    </div>
    <div class="w400 mb10" v-if="queryParams?.terminalId === '2'">
      <div class="mb4">未登录弹窗启用状态：</div>
      <a-radio-group
        :disabled="notDefaultLang"
        v-model:value="popupParams.guestPopupEnable"
        :options="[
          { label: '禁用', value: 0 },
          { label: '启用', value: 1 }
        ]"
      />
    </div>
    <div class="w400 mb10" v-if="queryParams?.terminalId === '2'">
      <div class="mb4">未登录弹窗延迟出现秒数：</div>
      <a-input-number
        :disabled="notDefaultLang"
        v-model:value="popupParams.guestPopupDelayTime"
        :min="0"
        :max="60"
        :step="1"
        placeholder="请输入"
      >
        <template #addonAfter>s</template>
      </a-input-number>
    </div>
    <div class="w400 mb10" v-if="queryParams?.terminalId === '1'">
      <div class="mb4"><span class="red">*</span>侧边栏背景色：</div>
      <ColorPicker
        format="rgb"
        v-model:pureColor="popupParams.sidebarColor"
        v-if="!notDefaultLang"
      />
      <div
        v-else
        style="width: 50px;height: 24px;"
        :style="`background: ${popupParams.sidebarColor}`"
      ></div>
    </div>
    <div class="w400 mb10" v-if="queryParams?.terminalId === '1'">
      <div class="mb4"><span class="red">*</span>文字颜色：</div>
      <ColorPicker
        format="rgb"
        v-model:pureColor="popupParams.sidebarContentColor"
        v-if="!notDefaultLang"
      />
      <div
        v-else
        style="width: 50px;height: 24px;"
        :style="`background: ${popupParams.sidebarContentColor}`"
      ></div>
    </div>
  </div>
  <div class="EditContainer df">
    <div>
      <div class="checkTabs mb20">
        <div
          :data-type="1"
          :class="
            `checkTab ${
              ![4, 7, 8, 9, 10, 11, 12, 20, 21, 22].includes(tabType)
                ? 'check'
                : ''
            }`
          "
          @click="() => tabTypeChange(1)"
        >
          订阅弹窗配置：Email
        </div>
        <div
          :class="
            `checkTab ${
              [9, 10, 11, 12, 20, 21, 22].includes(tabType) ? 'check' : ''
            }`
          "
          :data-type="9"
          @click="() => tabTypeChange(9)"
        >
          订阅弹窗配置：Email+Phone
        </div>
        <div
          :class="`checkTab ${tabType === 4 ? 'check' : ''}`"
          @click="() => tabTypeChange(4)"
          :data-type="4"
        >
          注册弹窗配置
        </div>
        <div
          :class="`checkTab ${[7, 8].includes(tabType) ? 'check' : ''}`"
          @click="() => tabTypeChange(7)"
          :data-type="7"
        >
          快捷注册弹窗
        </div>
      </div>

      <div
        class="mb10"
        v-if="
          [9, 10, 11, 12, 20, 21, 22].includes(tabType) &&
            queryParams.terminalId === '1'
        "
      >
        是否区分人群:
        <a-radio-group
          :disabled="notDefaultLang"
          :options="peopleStatusOptions"
          v-model:value="popupParams.peopleSupport"
          @change="handlePeopleChange"
        />
      </div>

      <a-radio-group
        v-if="
          [9, 10, 11, 12, 20, 21, 22].includes(tabType) &&
            popupParams.peopleSupport === 1 &&
            queryParams.terminalId === '1'
        "
        style="margin: 15px 0;"
        v-model:value="popupParams.peopleType"
      >
        <a-radio-button
          v-for="item in peopleTypeOptions"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </a-radio-button>
      </a-radio-group>

      <div class="mb10">
        默认币种:
        <span
          style="display: inline-block;padding: 7px 30px;background-color: lightgrey;"
          class="ml10"
        >
          {{ defaultCurrency }}
        </span>
      </div>

      <Subscription
        v-if="![4, 7, 8, 9, 10, 11, 12, 20, 21, 22].includes(tabType)"
      />
      <Sms
        v-if="[9, 10, 11, 12, 20, 21, 22].includes(tabType)"
        :notDefaultLang="notDefaultLang"
        ref="smsRef"
      />
      <Register v-if="tabType === 4" />
      <QuickRegister v-if="[7, 8].includes(tabType)" />
    </div>
  </div>
</template>
<script>
import Subscription from './Subscription.vue'
import Sms from './Sms.vue'
import Register from './Register.vue'
import QuickRegister from './QuickRegister.vue'
import { toRefs, reactive, inject, computed, watch, ref } from 'vue'
import { ColorPicker } from '@cupshe/vue3-colorpicker'
import 'vue3-colorpicker/style.css'
import {
  PictureOutlined,
  DeleteOutlined,
  EyeOutlined
} from '@ant-design/icons-vue'
export default {
  components: {
    Sms,
    Subscription,
    Register,
    PictureOutlined,
    DeleteOutlined,
    EyeOutlined,
    QuickRegister,
    ColorPicker
  },
  setup() {
    const injectState = inject('initState')
    const smsRef = ref()

    // 提供对外校验方法
    const validateSmsStyle2 = () => {
      if (smsRef.value && smsRef.value.validateSmsStyle2) {
        return smsRef.value.validateSmsStyle2()
      }
      return Promise.resolve(true)
    }
    const notDefaultLang = computed(
      () => injectState.langCode !== injectState.defaultLanguageCode
    )
    const state = reactive({})

    const triggerOptions = computed(() => {
      return injectState.queryParams?.terminalId === '1'
        ? [
            {
              label: '所有用户（新访+老访）',
              value: 1
            },
            {
              label: '新用户（新访）',
              value: 2
            },
            {
              label: '根据用户订阅状态',
              value: 4
            },
            {
              label: '未登陆用户',
              value: 5
            }
          ]
        : [
            {
              label: '根据用户订阅状态',
              value: 4
            }
          ]
    })

    watch(
      [
        () => injectState.popupParams.peopleSupport,
        () => injectState.popupParams.peopleType,
        () => injectState.tabType
      ],
      () => {
        const peopleKey =
          injectState.popupParams.peopleType == null
            ? null
            : injectState.popupParams.peopleType
        const key = `${peopleKey}-${injectState.tabType}`
        if ([20, 21, 22].includes(Number(injectState.tabType))) {
          if (!injectState.pepopleTabMap) injectState.pepopleTabMap = {}
          if (!injectState.pepopleTabMap[key])
            injectState.pepopleTabMap[key] = {
              peopleType: injectState.popupParams.peopleType,
              type: injectState.tabType,
              peopleSupport: injectState.popupParams.peopleSupport
            }
          if (!injectState.pepopleTabMap[key][injectState.langCode]) {
            injectState.pepopleTabMap[key][injectState.langCode] = {}
          }
        }
      }
    )

    return {
      ...toRefs(injectState),
      ...toRefs(state),
      smsRef,
      validateSmsStyle2,
      notDefaultLang,
      editorOption: {
        placeholder: '输入',
        modules: {
          toolbar: [
            [
              {
                font: [
                  'Muli-Light',
                  'Muli-SemiBold',
                  'Muli-Bold',
                  'Muli-ExtraBold'
                ]
              }
            ],
            [
              {
                size: [
                  '12px',
                  '14px',
                  '16px',
                  '18px',
                  '20px',
                  '22px',
                  '24px',
                  '26px',
                  '28px',
                  '30px',
                  '32px',
                  '34px',
                  '36px',
                  '38px',
                  '40px'
                ]
              }
            ],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E'
                ]
              }
            ]
          ]
        }
      },
      statusOptions: [
        {
          label: '禁用',
          value: 0
        },
        {
          label: '启用',
          value: 1
        }
      ],
      alertFormOptions: [
        {
          label: '订阅弹窗：Email',
          value: 1,
          disabled: injectState.queryParams?.terminalId !== '1'
        },
        {
          label: '订阅弹窗：Email+Phone',
          value: 5
        },
        {
          label: '注册弹窗',
          value: 2,
          disabled: injectState.queryParams?.terminalId !== '1'
        },
        {
          label: '快捷注册弹窗',
          value: 4,
          disabled: injectState.queryParams?.terminalId !== '1'
        }
      ],
      alertTimesOptions: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ],
      triggerOptions,
      sideTypeOptions: [
        {
          label: '文本',
          value: 1
        },
        {
          label: '图片',
          value: 2
        },
        {
          label: '个性化结合（PC右侧，M吸底）',
          value: 3
        }
      ],
      peopleStatusOptions: [
        {
          value: 1,
          label: '是'
        },
        {
          value: 0,
          label: '否'
        }
      ],
      peopleTypeOptions: [
        {
          label: '新访',
          value: 1
        },
        {
          label: '老访',
          value: 0
        }
      ]
    }
  }
}
</script>
<style>
.vc-colorpicker .vc-lightness-slider,
.vc-colorpicker .vc-display {
  display: flex !important;
}
</style>
<style lang="scss" scoped>
.editBread {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}
.EditContainer {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}

.checkTabs {
  width: 800px;
  height: 46px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
}

.checkTab {
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 3px;
  cursor: pointer;
}

.checkTab.check {
  background: #ffffff;
}

.checkPicTabs {
  width: 146px;
  height: 36px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
  margin: 0 auto 20px auto;
}

.checkPicTab {
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
}

.checkPicTab.check {
  background: #ffffff;
}

.EditContainerRight {
  background: #f4f4f4;
  width: 400px;
  padding: 14px;
  margin: 14px;
}

.sidebarContentBg .hover {
  width: 120px;
  height: 120px;
  display: none;
  cursor: pointer;
  color: #ffffff;
  text-align: center;
  line-height: 120px;
  background: rgba(0, 0, 0, 0.3);
}

.sidebarContentBg:hover .hover {
  display: block;
}
.radio-wrapper {
  display: flex;
  align-items: center;
  .radio-tips {
    font-size: 12px;
    .input-style {
      width: 30px;
      padding: 0;
    }
  }
}
.label-df {
  display: flex;
}
.colorBlock {
  width: 50px;
  height: 24px;
  display: inline-block;
}
</style>
<style>
.sidebarTypeImg .ant-upload.ant-upload-drag .ant-upload {
  padding: 0;
}
</style>
